import analytics from '@nerdwallet/analytics';
import { SegmentEventTrackerT } from './types';
import { FORM_VIEWED_EVENT } from './eventTypes';

/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable camelcase */

type SegmentFormEventPayloadT = {
  deployable_name: string;
  deployable_version: string;
  entityName: string;
  formName: string;
};

export const trackFormImpression: SegmentEventTrackerT<
  SegmentFormEventPayloadT,
  string
> = (
  { entityName, formName, deployable_name, deployable_version },
  segmentInstance
) => {
  const evtId = analytics.uuid();

  segmentInstance.track(FORM_VIEWED_EVENT, {
    deployable_name,
    deployable_version,
    entity_name: entityName,
    form_name: formName,
    event_id: evtId,
  });

  return evtId;
};
